/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import type { SearchParams } from '@/server/searchParams.ts';
import { useTranslation } from '@/app/components/translations/Translation';
import { FilterSearchDynamicModalHeadingStyled } from '@/app/common/filters/types/searchDynamic/styled.ts';
import { type PropertyNameSelected, PropertyNameSelector } from './PropertyNameSelector';
import {
  PropertyNameModalCloseStyled,
  PropertyNameModalStyled,
  PropertyNameModalTitleNameStyled,
  PropertyNameModalTitleStyled,
} from './styled';
import CloseIcon from './CloseIcon';

type Props = {
  searchParams: SearchParams;
  name: string;
  onUpdate: (e: any) => void;
  value: string;
  setShowModal: React.Dispatch<React.SetStateAction<boolean>>;
  isMobile: boolean;
};

export const PropertyNameModal = ({ searchParams, name, onUpdate, value, setShowModal, isMobile }: Props) => {
  const handleCloseClicked = () => {
    setShowModal(false);
  };
  const { t } = useTranslation();
  const handleOnUpdate = (selectedProps: PropertyNameSelected) => {
    if (selectedProps?.target?.value) {
      setShowModal(false);
    }
    onUpdate(selectedProps);
  };

  return (
    <PropertyNameModalStyled>
      <FilterSearchDynamicModalHeadingStyled>
        <PropertyNameModalTitleStyled>
          <PropertyNameModalCloseStyled onClick={handleCloseClicked}>
            <CloseIcon />
          </PropertyNameModalCloseStyled>
          <PropertyNameModalTitleNameStyled>
            {t('vacation.oss.filters.property.title')}
          </PropertyNameModalTitleNameStyled>
        </PropertyNameModalTitleStyled>
        <PropertyNameSelector
          searchParams={searchParams}
          name={name}
          onUpdate={handleOnUpdate}
          value={value}
          isMobile={isMobile}
        />
      </FilterSearchDynamicModalHeadingStyled>
    </PropertyNameModalStyled>
  );
};
